<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-3">
				<h2>Podaj zainteresowania</h2>
			</div>

			<v-container grid-list-md text-xs-center>
				<v-layout row wrap justify-center>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-textarea
							browser-autocomplete="off"
							outline
							label="Zainteresowania"
							aria-label="label for interests description"
							for="step-interests-data-component-interests"
							id="step-interests-data-component-interests"
							v-model="stepData.interests.description"
						></v-textarea>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-textarea
							browser-autocomplete="off"
							outline
							label="Uzasadnienie zainteresowania wolontariatem zagranicznym"
							aria-label="label for interests justification"
							for="step-interests-data-component-confirmation"
							id="step-interests-data-component-confirmation"
							v-model="stepData.interests.confirmation"
						></v-textarea>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-textarea
							browser-autocomplete="off"
							outline
							label="Dotychczasowe doświadczenie w pracy wolontariackiej"
							aria-label="label for working experience"
							for="step-interests-data-component-experience"
							id="step-interests-data-component-experience"
							v-model="stepData.interests.workingExperience"
						></v-textarea>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-textarea
							browser-autocomplete="off"
							outline
							label="Dodatkowe informacje uzupełniające"
							aria-label="label for extra information"
							for="step-interests-data-component-extra-information"
							id="step-interests-data-component-extra-information"
							v-model="stepData.interests.extraInformation"
						></v-textarea>
					</v-flex>
					<v-flex xs3>
					</v-flex>

				</v-layout>
			</v-container>

		</v-card>
		<v-btn color="blue"
			@click="$emit('step', 3)"
		>Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 5)">
			Dalej
		</v-btn>
	</div>
</template>

<script>
	export default {
		name: "StepInterestsDataComponent",
		inject: ["parentValidator"],

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {};
		},

		props: {
			stepData: Object,
		},
	};
</script>

<style scoped>

</style>
